/**
 * Модуль FAQ для лендингов.
 */
export function initFaq() {
    document.querySelectorAll('.faq__item').forEach((item) => {
        const trigger = item.querySelector('.faq__trigger');
        if (!trigger) {
            return;
        }

        trigger.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');
            document.querySelectorAll('.faq__item.is-open').forEach((openItem) => {
                openItem.classList.remove('is-open');
                const openTrigger = openItem.querySelector('.faq__trigger');
                if (openTrigger) {
                    openTrigger.setAttribute('aria-expanded', 'false');
                }
            });

            if (!isOpen) {
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
            }
        });
    });
}
